
<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
  <div id="page-login">
    <div class="body"></div>
    <div class="grad"></div>
    <div class="header">
      <img :src="src_logo" class="w-0" />
    </div>
    <br />
    <div class="login">
      <!-- <vs-input type="text" v-model="email"  icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="Nom d'utilisateur" class="w-full" />
        <vs-input type="password" v-model="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="Mot de passe"  class="w-full mt-6" /> -->

      <input type="text" placeholder="Nom d'utilisateur" name="email" v-model="email" /><br />
      <input v-on:keyup="loginJWT($event)" type="password" placeholder="Mot de passe" name="password" v-model="password" /><br />
      <input type="button" value="Connecter" :disabled="!validateForm" @click="loginJWT" />
    </div>
  </div>
</template>

<script>
import authService from "../../../auth/authService";
export default {
  data() {
    return {
      email: "",
      password: "",
      src_logo: require("@/assets/images/logo/logo-login.png"),
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
  },
  methods: {
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        this.$router.push("/Commande/Nouveau");
        return false;
      }
      return true;
    },
    loginJWT(e) {
      if (e.keyCode === 13 || e.type === "click") {
        if (!this.checkLogin()) return;
        this.$vs.loading();
        this.$vs.loading({
          background: "#ffffff",
          color: "#ffffff",
        });
        const payload = {
          userDetails: {
            email: this.email,
            password: this.password,
          },
        };

        this.$store
          .dispatch("auth/loginJWT", payload)
          .then((response) => {
            console.log(response);
            this.$acl.change(authService.getRole());

            localStorage.setItem("username", this.email);


            //*****************************************Redirection suivant le role***************************************************** */
            /* if(authService.getRole()== "GestionnairePortail"){
              this.$router.push("/actualites");
            }else{
               this.$router.push("/Commande/Nouveau");
            } */
            console.log("role compte connecté maintenant", authService.getRole())
            console.log("active user : ", this.$store.state.AppActiveUser)
            switch (authService.getRole()) {
              case "GestionnairePortail":
                this.$router.push("/actualites");
              break;
              case "Simple":
                this.$router.push("/Commande/Nouveau");
              break;
              case "Admin":
                this.$router.push("/Commande/Nouveau");
              break;
              case "SuperAdmin":
                this.$router.push("/Commande/Nouveau");
              break;
              case "TeleCogepha":
                this.$router.push("/televente");
              break;
              default:
                console.log(`Sorry, we are out of ${roleCompte}.`);
            }


            

            //***************************************** Fin Redirection suivant le role***************************************************** */

            
           
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
            this.usernameerror = "Email ou mode de passe incorrect";
            this.$vs.notify({
              title: "",
              text: "Nom d'utilisateur ou mot de passe incorrect ",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
#page-login {
  @import url(https://fonts.googleapis.com/css?family=Exo:100,200,400);
  @import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:700,400,300);

  body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: #fff;
    font-family: Arial;
    font-size: 18px;
  }

  .body {
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: 0px;
    width: auto;
    height: auto;
    background-image: url(../../../assets/images/pages/loginPortail.jpg);
    background-size: cover;

    z-index: 0;
  }

  .grad {
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: 0px;
    width: auto;
    height: auto;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0.65)));
    /* Chrome,Safari4+ */
    z-index: 1;
    opacity: 0.7;
  }

  .header {
    position: absolute;
    top: calc(50% - 190px);
    left: calc(50% - 143px);
    z-index: 2;
  }

  .header div {
    float: left;
    color: #c9d300;
    font-family: "Exo", sans-serif;
    font-size: 35px;
    font-weight: 200;
    font-weight: bold;
  }

  .header div span {
    color: #01b3e1 !important;
  }

  .login {
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 149px);
    height: 150px;
    width: 350px;
    padding: 10px;
    z-index: 2;
  }

  .login input[type="text"] {
    width: 280px;
    height: 30px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 2px;
    color: #fff;
    font-family: "Exo", sans-serif;
    font-size: 16px;
    font-weight: 400;
    padding: 4px;
  }

  .login input[type="password"] {
    width: 280px;
    height: 30px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 2px;
    color: #fff;
    font-family: "Exo", sans-serif;
    font-size: 16px;
    font-weight: 400;
    padding: 4px;
    margin-top: 10px;
  }

  .login input[type="button"] {
    width: 120px;
    height: 35px;
    background: #01b3e1;
    border: 1px solid #fff;
    cursor: pointer;
    border-radius: 2px;
    color: #ffffff;
    font-family: "Exo", sans-serif;
    font-size: 16px;
    font-weight: 400;
    // padding: 6px;
    margin-left: 80px;
    margin-right: 20px;
    margin-top: 20px;
    opacity: 0.5;
  }

  .login input[type="button"]:hover {
    opacity: 0.8;
  }

  .login input[type="button"]:active {
    opacity: 0.6;
  }

  .login vs-input[type="text"]:focus {
    outline: none;
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .login vs-input[type="password"]:focus {
    outline: none;
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .login input[type="button"]:focus {
    outline: none;
  }

  ::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  ::-moz-input-placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
